import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Table,
	Form,
	Input,
	Button,
	Select,
	List,
	Radio,
	Card,
	Cascader,
	Switch,
	Popconfirm,
	Modal,
	Divider,
	Image,
	Row,
	Col,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	parseTime,
	httpPost
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'orderId':0,
			'info':{
				'extra_info':{
					'order_category':[],
				},
				'image_list':[],
			},
		};
	}
	
	componentDidMount()
	{
	}
	
	init(id)
	{
		this.state.orderId = id;
		this.getInfo();
	}
	
	getInfo()
	{
		//获取订单详情
		let url = pcUrl('order','detail');
		let param = {
			'order_id':this.state.orderId,
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'info':data,
				});
			});
	}
	
	render()
	{
		return (
				<div className="font-form">
					{this.state.info['order_type'] != 1 && (
						<Table pagination={false} dataSource={this.state.info['image_list']} scroll={{'x':true}}>
							<Column title="正面" ellipsis={true} width={100} fixed dataIndex="image_name" render={(text,row,index)=>(
								<>
									<Image preview={{'src':row['image_path']['image_name']}} width={80} height={80} src={row['image_path']['thumb_name']} alt={row.image_name} />
									{/*
									&nbsp;&nbsp;
									{row.image_name}
									*/}
								</>
							)} />
							<Column title="反面" ellipsis={true} width={100} dataIndex="back_path" render={(text,row,index)=>(
								<>
									{row['back_path'] ? (
										<Image preview={{'src':row['back_path']['thumb_name']}} width={80} height={80} src={row['back_path']['thumb_name']} alt={row.image_name} />
									):''}
								</>
							)} />
							<Column title="异形" ellipsis={true} width={100} dataIndex="spec_path" render={(text,row,index)=>(
								<>
									{row['spec_path'] ? (
										<>
										<a href={row['spec_path']} target="_blank">下载</a>
										{/*
										<span style={{'color':'#999'}}>Oss中下载</span>
										*/}
										</>
									):''}
								</>
							)} />
							<Column title="材料" ellipsis={true} width={100} dataIndex="categories" width={100} render={(text,row,index)=>(
								<>
									{row['categories'][1].map(row=>(
										<>
											{row}
											<br />
										</>
									))}
								</>
							)} />
							<Column title="图片尺寸" ellipsis={true} width={100} dataIndex="image_dimension" render={(text,row,index)=>(
								<>
									{row['image_dimension'].split('*').map(row=>row+'CM').join('*')}
								</>
							)} />
							<Column title="订单编号" ellipsis={true} width={100} dataIndex="order_sn" width={100} render={(text,row,index)=>this.state.info['order_sn']} />
							<Column title="单价" ellipsis={true} width={100} dataIndex="image_price" render={(text,row,index)=>'￥'+row['image_price']} />
							<Column title="数量" ellipsis={true} width={100} dataIndex="quantity" />
							<Column title="原价" ellipsis={true} width={100} dataIndex="image_amount" render={(text,row,index)=>'￥'+row['image_amount']} />
							<Column title="应付金额" ellipsis={true} width={100} dataIndex="pay_amount" render={(text,row,index)=>'￥'+row['pay_amount']} />
							<Column title="备注" ellipsis={true} width={200} dataIndex="remark" />
							<Column title="状态" ellipsis={true} width={100} fixed="right" dataIndex="image_status_exp" />
						</Table>
					)}
					{this.state.info['order_type'] == 1 && (
						<Table pagination={false} dataSource={this.state.info['goods_list']} scroll={{'x':true}}>
							<Column title="商品名称" ellipsis={true} width={100} dataIndex="goods_name" />
							<Column title="商品分类" ellipsis={true} width={100} dataIndex="category_name" />
							<Column title="缩略图" ellipsis={true} width={120} dataIndex="goods_thumb" render={(text,row,index)=>(
								<Image src={row['goods_thumb']['thumb_name']} preview={{src:row['goods_thumb']['image_name']}} height={80} />
							)} />
							{!+this.state.info['is_points']?(
								<Column title="商品价格" ellipsis={true} width={100} dataIndex="goods_price" render={(text,row,index)=>'￥'+row['goods_price']} />
							):(
								<Column title="商品积分" ellipsis={true} width={100} dataIndex="goods_price" render={(text,row,index)=>row['goods_price']+'积分'} />
							)}
							<Column title="商品规格" ellipsis={true} width={100} dataIndex="goods_spec" />
							<Column title="数量" ellipsis={true} width={100} dataIndex="quantity" />
							{!+this.state.info['is_points']?(
								<Column title="原价" ellipsis={true} width={100} dataIndex="goods_amount" render={(text,row,index)=>'￥'+row['goods_amount']} />
							):(
								<Column title="原积分" ellipsis={true} width={100} dataIndex="goods_amount" render={(text,row,index)=>row['goods_amount']+'积分'} />
							)}
							{!+this.state.info['is_points']?(
								<Column title="应付金额" ellipsis={true} width={100} dataIndex="pay_amount" render={(text,row,index)=>'￥'+row['pay_amount']} />
							):(
								<Column title="应付" ellipsis={true} width={100} dataIndex="pay_amount" render={(text,row,index)=>row['pay_amount']+'积分'} />
							)}
						</Table>
					)}
					<div class="height-10"></div>
					<Divider plain>订单信息</Divider>
					<div class="height-10"></div>
					<Row gutter={16}>
						<Col span={12}>
							<Form
								labelCol={{ span:7 }}
								wrapperCol={{ span:18 }}
								ref={e=>this.mainForm = e}>
								<Form.Item label="订单编号">
									{this.state.info['order_sn']}
								</Form.Item>
								<Form.Item label="交付时间">
									{this.state.info['delivery_name']}
								</Form.Item>
								{!+this.state.info['is_points']?(
								<Form.Item label="订单金额">
									<span className="text-orange"> ￥{+this.state.info['order_amount']}元 </span>
									{this.state.info['original_amount'] != this.state.info['order_amount'] && (
										<span className="line-through text-gray" style={{'font-size':'12px'}}> ￥{+this.state.info['original_amount']}元  </span>
									)}
								</Form.Item>
								):(
								<Form.Item label="订单金额">
									<span className="text-orange"> {+this.state.info['order_amount']}积分 </span>
									{this.state.info['original_amount'] != this.state.info['order_amount'] && (
										<span className="line-through text-gray" style={{'font-size':'12px'}}> {+this.state.info['original_amount']}积分  </span>
									)}
								</Form.Item>
								)}
								{this.state.info['coupon_sn'] ? (
									<Form.Item label="优惠券">
										{this.state.info['coupon_sn']}
									</Form.Item>
								):''}
								
								<Form.Item label="下单时间">
									{parseTime(this.state.info['add_time'])}
								</Form.Item>
								<Form.Item label="订单状态">
									{this.state.info['order_status_exp']}
								</Form.Item>
							</Form>
						</Col>
						<Col span={12}>
							<Form
								labelCol={{ span:7 }}
								wrapperCol={{ span:18 }}
								ref={e=>this.mainForm = e}>
								<Form.Item label="配送方式">
									{this.state.info['extra_info']['shipping_method_exp']}
								</Form.Item>
								<Form.Item label="收货姓名">
									{this.state.info['extra_info']['reciver_consignee']}
								</Form.Item>
								<Form.Item label="联系电话">
									{this.state.info['extra_info']['reciver_phone']}
								</Form.Item>
								<Form.Item label="城市信息">
									{this.state.info['extra_info']['reciver_area_info']}
								</Form.Item>
								<Form.Item label="收货地址">
									{this.state.info['extra_info']['reciver_address']}
								</Form.Item>
							</Form>
						</Col>
						{/*
						<Col span={8}>
							<Form
								labelCol={{ span:7 }}
								wrapperCol={{ span:18 }}
								ref={e=>this.mainForm = e}>
								{this.state.info['extra_info']['order_category'].map(row=>(
									<Form.Item label={row['label']}>
										{row['exp']}
									</Form.Item>
								))}
							</Form>
						</Col>
						*/}
					</Row>
				</div>
		);
	}
}


